export enum ToastrPositionClassType {
    TOP_CENTER = 'toast-top-center',
    BOTTOM_CENTER = 'toast-bottom-center'
 }